export enum NOTA_REMISION_TYPES {
    NR_SET_VIEW = 'NR_SET_VIEW',
    NR_SET_FORM_CLIENTE = 'NR_SET_FORM_CLIENTE',
    NR_HANDLE_ERRORS_CLIENTE = 'NR_HANDLE_ERRORS_CLIENTE',
    NR_SET_FORM_PRODUCTO = 'NR_SET_FORM_PRODUCTO',
    NR_HANDLE_ERRORS_PRODUCTO = 'NR_HANDLE_ERRORS_PRODUCTO',
    NR_SET_PRODUCTOS = 'NR_SET_PRODUCTOS',
    NR_SET_PRODUCTO_EDIT = 'NR_SET_PRODUCTO_EDIT',
    NR_SET_PRODUCTO_INDEX = 'NR_SET_PRODUCTO_INDEX',

    NR_ACTIVE_MODAL_EDITAR_PRODUCTO = 'NR_ACTIVE_MODAL_EDITAR_PRODUCTO',
    NR_ACTIVE_MODAL_ELIMINAR_PRODUCTO = 'NR_ACTIVE_MODAL_ELIMINAR_PRODUCTO',
    NR_ACTIVE_MODAL_QUITAR_TODO = 'NR_ACTIVE_MODAL_QUITAR_TODO',
    NR_ACTIVE_MODAL_EMITIR = 'NR_ACTIVE_MODAL_EMITIR',
    NR_ACTIVE_MODAL_EMITIDO = 'NR_ACTIVE_MODAL_EMITIDO',
    NR_ACTIVE_MODAL_MAS_OPCIONES = 'NR_ACTIVE_MODAL_MAS_OPCIONES',
    NR_ACTIVE_MODAL_ENVIAR_CORREO = 'NR_ACTIVE_MODAL_ENVIAR_CORREO',
    NR_ACTIVE_MODAL_IMPRIMIR = 'NR_ACTIVE_MODAL_IMPRIMIR',
    NR_ACTIVE_MODAL_ANULAR = 'NR_ACTIVE_MODAL_ANULAR',
    NR_ACTIVE_MODAL_ANULADO = 'NR_ACTIVE_MODAL_ANULADO',
    NR_ACTIVE_MODAL_BUSQUEDA_DOCUMENTO = 'NR_ACTIVE_MODAL_BUSQUEDA_DOCUMENTO',

    NR_SET_QR_CODE = 'NR_SET_QR_CODE',
    NR_SET_RESPONSE_EMITIR = 'NR_SET_RESPONSE_EMITIR',

    NR_SET_CALCULOS_PRODUCTO = 'NR_SET_CALCULOS_PRODUCTO',
    NR_SET_CALCULOS_GENERALES = 'NR_SET_CALCULOS_GENERALES',

    NR_RESTART_FORM_PRODUCTO = 'NR_RESTART_FORM_PRODUCTO',
    NR_RESTART_ALL = 'NR_RESTART_ALL',
    NR_SET_CLIENTE_ENCONTRADO = 'NR_SET_CLIENTE_ENCONTRADO',
    NR_ACTIVE_MODAL_CLIENTE_ENCONTRADO = 'NR_ACTIVE_MODAL_CLIENTE_ENCONTRADO',

    NR_ACTIVE_ASOCIAR_DOCUMENTOS = 'NR_ACTIVE_ASOCIAR_DOCUMENTOS',
    NR_SET_DOCUMENTOS_ENCONTRADOS = 'NR_SET_DOCUMENTOS_ENCONTRADOS',
    NR_SET_DOCUMENTOS_ASOCIADOS = 'NR_SET_DOCUMENTOS_ASOCIADOS',
    NR_SET_LOADER_DOCUMENTOS_ASOCIADOS = 'NR_SET_LOADER_DOCUMENTOS_ASOCIADOS',
    NR_ACTIVE_ADVERTENCIA_ASOCIAR_DOCUMENTOS = 'NR_ACTIVE_ADVERTENCIA_ASOCIAR_DOCUMENTOS',

    NR_SET_FORM_BUSQUEDA_DOCUMENTO = 'NR_SET_FORM_BUSQUEDA_DOCUMENTO',
    NR_HANDLE_ERRORS_BUSQUEDA_DOCUMENTO = 'NR_HANDLE_ERRORS_BUSQUEDA_DOCUMENTO',
    NR_HANDLE_ACTIVE_MOSTRAR_DETALLE = 'NR_HANDLE_ACTIVE_MOSTRAR_DETALLE',
    NR_SET_TABLE_PRODUCTOS = 'NR_SET_TABLE_PRODUCTOS',

    NR_ACTIVE_MODAL_DOCUMENTO_FISICO = 'NR_ACTIVE_MODAL_DOCUMENTO_FISICO',
    NR_ACTIVE_MODAL_PRODUCTO_FISICO = 'NR_ACTIVE_MODAL_PRODUCTO_FISICO',
    NR_ACTIVE_MODAL_EDITAR_PRODUCTO_FISICO = 'NR_ACTIVE_MODAL_EDITAR_PRODUCTO_FISICO',
    NR_FORMOBSERVACIONES_HANDLE_CHANGE = 'NR_FORMOBSERVACIONES_HANDLE_CHANGE',
}
